var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFD15B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2426 4769 c-74 -25 -132 -64 -185 -125 -39 -44 -129 -220 -463 -902 -55 -112 -105 -205 -111 -208 -7 -2 -275 -42 -596 -89 -538 -78 -588 -87 -647 -116 -122 -58 -211 -177 -235 -317 -14 -79 0 -161 41 -250 27 -58 59 -93 303 -331 149 -146 345 -337 433 -426 l162 -160 -99 -570 c-54 -314 -98 -595 -99 -626 -1 -165 112 -328 270 -391 69 -27 222 -31 286 -7 23 9 274 138 558 287 l517 272 522 -275 c330 -173 544 -280 582 -290 105 -27 196 -15 303 39 133 67 223 218 222 371 0 27 -45 306 -100 620 l-98 570 166 165 c92 91 287 283 433 425 292 285 316 316 340 447 32 175 -71 372 -235 449 -58 27 -116 37 -648 115 -320 46 -589 88 -595 92 -11 6 -280 540 -463 917 -95 196 -164 269 -298 314 -81 28 -186 27 -266 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/FillStar.4bffd820937eea2866d819c09a6b2daf.svg";
export { ForwardRef as ReactComponent };